module.exports = __webpack_public_path__ + "static/media/my_answer_no_content.ed286967.png";